import { Info } from 'lucide-react';
import colorSet from '@/styles/color';

interface Props {
  widthSize?: number;
  heightSize?: number;
}

function ImageUploadInfo({ widthSize, heightSize }: Props) {
  return (
    <div className="flex items-start gap-[6px] text-b14r text-gray5">
      <div>
        <Info size={20} color={colorSet.gray5} className="flex-shrink-0" />
      </div>
      <div className="flex flex-col gap-1">
        <span>
          등록 가능한 파일은 PNG, JPG, GIF 입니다. (팝업형으로 제한 크기는 5MB
          이하)
        </span>
        <span>
          {/* expect text : 권장 사이즈 335x335(px) 이상*/}
          {`권장 사이즈 ${widthSize}x${heightSize}(px) 이상`}
        </span>
      </div>
    </div>
  );
}

export default ImageUploadInfo;
